/**
 * Account Domain Services
 * Expose all services to register user accounts, create, read, update and delete documents registered in User Account Repository
 *
 * OpenAPI spec version: 1-0
 * Contact: suporte-api-digital@br.experian.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { Observable }                                        from 'rxjs';
import {environment} from "../../../../../environments/environment";
import {ApiService} from "../../util/api.service";
import { HeadersRequest } from '../../util/model/header-request.inteface';


@Injectable()
export class UserAccountsService {

    private basePath = environment.basePathAccount;

    constructor(protected apiService: ApiService, @Optional() @Inject('basePath') basePath: string) {
      if (basePath) {
        this.basePath = basePath;
      }
    }


    public authFindUserById(authorization: string): Observable<any> {

        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling authFindUserById.');
        }

        const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
        headers.push({param: 'Authorization', value: 'Bearer ' + authorization});
        headers.push({param: 'Content-Type', value: 'application/json'});
        headers.push({param: 'Origin', value: 'http://localhost:4200'});

        const uri: string = environment.userAccounts.me;
        return this.apiService.get<any>(this.basePath + uri,null, headers);

    }


}
